module.exports = "<div class=\"card\">\r\n  <div class=\"card-body\">\r\n    <spk-search-grid #grid list=\"RoleSearchRow\" title=\"Roles\" defaultSortProperty=\"Name\" [leftLinks]=\"leftLinks\" [csvExport]=\"true\"></spk-search-grid>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/security/roles/roles.component.html
// module id = ./src/app/components/security/roles/roles.component.html
// module chunks = main